import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import getClassNames from 'classnames';
import ConnectionsTag from '../connections-tag';
import ConnectionsTagTypeAheadContainer from './connections-tags-typeahead/typeahead-container';
import ReactTransitionGroup from 'react-addons-transition-group';
import { addTag, removeTag } from '../../../stores/connections/connections-actions';

class TagsContainer extends Component {
  addOrRemoveTag = (tagName, addOrRemove) => {
    const { connectionId, addATag, delTag } = this.props;
    if (this.props.allUserTags && this.props.allUserTags.indexOf(tagName) === -1) {
      if (addOrRemove === 'add') addATag(connectionId, tagName);
    }
    if (addOrRemove === 'remove') delTag(connectionId, tagName);
  }

  render() {
    // Iterate through tags and append a comma if not first tag
    const tags = (() => {
      if (this.props.tags) {
        return this.props.tags.map((tag, index) =>
            <ConnectionsTag
              isTagModal={this.props.isTagModal}
              addOrRemoveTag={this.addOrRemoveTag}
              connectionId={this.props.connectionId}
              className="connections-tags"
              tag={tag}
              key={index}
            />);
      }
    })();

    const classes = getClassNames(this.props.className, {
      'connections-tags-container': !this.props.typeAheadOpen,
      'connections-typeahead-container': this.props.typeAheadOpen,
    });

    return (
      <div className={classes}>
        <ConnectionsTagTypeAheadContainer
          addOrRemoveTag={this.addOrRemoveTag}
          allUserTags={this.props.allUserTags}
          open={this.props.typeAheadOpen}
          connectionId={this.props.connectionId}
          toggleTypeAhead={this.props.toggleTypeAhead}
        />
        <div className="individual-tags-container">
          <ReactTransitionGroup >
            {tags}
          </ReactTransitionGroup>
        </div>
      </div>
    );
  }
}

TagsContainer.propTypes = {
  dispatch: PropTypes.func,
  connectionId: PropTypes.string,
  allUserTags: PropTypes.array,
  tags: PropTypes.array,
  className: PropTypes.string,
  isTagModal: PropTypes.bool,
  typeAheadOpen: PropTypes.bool,
  toggleTypeAhead: PropTypes.bool,
  addATag: PropTypes.func,
  delTag: PropTypes.func,
};

const mapDispatchToProps = dispatch => ({
  addATag: (connectionId, tagName) => dispatch(addTag(connectionId, tagName)),
  delTag: (connectionId, tagName) => dispatch(removeTag(connectionId, tagName)),
});

export default connect(null, mapDispatchToProps)(TagsContainer);



// WEBPACK FOOTER //
// ./src/app/components/connections/connections-tags-modal/connections-tags-container.jsx